if (!customElements.get('mixed-bogo-selects')) {
  customElements.define('mixed-bogo-selects',
    class MixedBogoSelects extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          this.updateSelectionMetadata(event);
        });
      }

      updateSelectionMetadata({ target }) {
        requestAnimationFrame(() => {
          this.mixedBogoInput = this.querySelectorAll('[data-mixed-bogo-input]');
          const checkedBogoInput = Array.from(this.mixedBogoInput).find(input => input.checked);
          let additionalVariantId;

          const pickers = this.querySelectorAll('.mixed-bogo__variant-picker');
          if (checkedBogoInput?.hasAttribute('data-picker-id')) {
            const pickerId = checkedBogoInput.getAttribute('data-picker-id');
            pickers.forEach(p => p.classList.remove('is-open'));
            const targetPicker = this.querySelector(`#${pickerId}`);
            if (targetPicker) targetPicker.classList.add('is-open');
            additionalVariantId = targetPicker.querySelector('.js-option-value-id').value;
          } else {
            pickers.forEach(p => p.classList.remove('is-open'));
            additionalVariantId = checkedBogoInput.nextElementSibling.querySelector('.js-option-value-id').value;
          }

          sessionStorage.setItem('additionalVariantId', additionalVariantId);
        });
      }
    }
  );
}